var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserEmployee || _vm.isUserEmployer ? _c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "baseline"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "8",
      "color": _vm.color_icon
    }
  }, [_vm._v("mdi-circle")])], 1), _c('v-col', {
    staticClass: "page-text--sm",
    staticStyle: {
      "color": "#111"
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }